import axios from './axiosConfig';

const API_URL = process.env.NODE_ENV === 'production'
  ? "https://api.demo1.raborisk.ai"
  : "http://localhost:3000";

const PYTHON_API_URL = process.env.NODE_ENV === 'production'

  ? "https://api.ai.raborisk.ai"
  : "http://localhost:8000";

export const TOGGLE_CHATBOT = 'TOGGLE_CHATBOT';
export const SHOW_CHATBOT = 'SHOW_CHATBOT';
export const HIDE_CHATBOT = 'HIDE_CHATBOT';


export const toggleChatbot = () => ({ type: TOGGLE_CHATBOT });
export const showChatbot = () => ({ type: SHOW_CHATBOT });
export const hideChatbot = () => ({ type: HIDE_CHATBOT });



export const sendChatMessageNode = (message) => {
  return async (dispatch) => {
    dispatch({ type: 'CHATBOT_MESSAGE_SEND_START' });

    try {
      const response = await axios.post(`${API_URL}/api/ai/chat`, { message });
      console.log('API response:', response.data); // add this

      dispatch({
        type: 'CHATBOT_MESSAGE_SEND_SUCCESS',
        payload: response.data.reply, // assuming the backend responds with { reply: '...' }
      });

      return response.data.reply;
    } catch (error) {
      console.error('Chatbot message error:', error);
      dispatch({
        type: 'CHATBOT_MESSAGE_SEND_FAILURE',
        payload: error.message,
      });
      throw error;
    }
  };
};

export const sendChatMessage = (message) => {
  return async (dispatch) => {
    dispatch({ type: "CHATBOT_MESSAGE_SEND_START" });

    const ctrl = new AbortController();            // optional: allow cancel
    const res  = await fetch(`${PYTHON_API_URL}/chat`, {
      method:  "POST",
      headers: { "Content-Type": "application/json" },
      body:    JSON.stringify({ message }),
      signal:  ctrl.signal,
    });

    if (!res.ok) throw new Error(`HTTP ${res.status}`);

    dispatch({ type: "CHATBOT_MESSAGE_SEND_START_BOT" }); 
    const reader = res.body.getReader();
    const decoder = new TextDecoder();

    let full = "";

    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      const chunk = decoder.decode(value, { stream: true });
      full += chunk;                               // accumulate if you need full answer

      // each chunk is a partial token – dispatch for live UI updates
      dispatch({
        type: "CHATBOT_MESSAGE_PARTIAL",
        payload: chunk,
      });
    }

    dispatch({
      type: "CHATBOT_MESSAGE_SEND_SUCCESS",
      payload: full.trim(),                        // final message
    });

    return full.trim();
  };
};